export default __webpack_public_path__ + "static/media/Snd_ClowerG.44ea9e0b.mp3";